import { Box } from '@mui/material';
import AlertLogo from 'components/AlertLogo';
import { Outlet } from 'react-router-dom';
import { LayoutStyle } from './styles';
const MainLayout = () => {
    return (
        <Box sx={LayoutStyle}>
            {/* <AlertLogo /> */}
            <Outlet />
            <AlertLogo />
        </Box>
    );
};
export default MainLayout;
